<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">クロス設定登録</th>
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <!-- クロス商品一覧 -->
        <div class="element-column">
          <wj-flex-grid id="dtg_CrossGoodsInfoList" #dtg_CrossGoodsInfoList [allowAddNew]="false"
            [itemsSource]="kymw4801Model.crossGoodsInfoList" [headersVisibility]="'All'" [style.width.px]="654"
            [style.height.px]="255" [isReadOnly]="true" [tabindex]="-1" [alternatingRowStep]="0"
            [selectionMode]="'Row'" [allowSorting]="false" [allowDragging]="'Rows'"
            (draggingRow)="onDraggingRow(dtg_CrossGoodsInfoList, $event)"
            (draggedRow)="onDraggedRow(dtg_CrossGoodsInfoList, $event)">
            <!-- 掲載順 -->
            <wj-flex-grid-column [minWidth]="5" [width]="60" [header]="'掲載順'" [binding]="'PublishSeq'"
              [align]="'right'"></wj-flex-grid-column>
            <!-- Ｐコード -->
            <wj-flex-grid-column [minWidth]="5" [header]="'Ｐコード'" [width]="110" [binding]="'PCode'"
              [isReadOnly]="true">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <!-- 編集不可 -->
                <ng-container
                  *ngIf="getPcodeMatch(0,cell.item.PCode) then ReadOnlyPcode; else AllowEditPcode"></ng-container>
                <ng-template #ReadOnlyPcode>
                  <span [style.width.%]="100">{{cell.item.PCode}}</span>
                </ng-template>
                <!-- 編集可 -->
                <ng-template #AllowEditPcode>
                  <input type="text" [(ngModel)]="cell.item.PCode" plessInputTextSub [maxLength]="8"
                    [restrict]="'[P0-9]'" [tabindex]="-1" [style.width.%]="100"
                    (blur)="eventTxt_Pcode_FOCUS_OUTHandler($event)" (focus)="eventTxt_Pcode_FOCUS_INHandler()">
                </ng-template>
              </ng-template>
            </wj-flex-grid-column>
            <!-- 商品名 -->
            <wj-flex-grid-column [minWidth]="5" [width]="200" [header]="'商品名'"
              [binding]="'GuideGoodsName'"></wj-flex-grid-column>
            <!-- 規格名 -->
            <wj-flex-grid-column [minWidth]="5" [width]="120" [header]="'規格名'"
              [binding]="'GuideStandardName'"></wj-flex-grid-column>
            <!-- 子コマ配置 -->
            <wj-flex-grid-column [minWidth]="5" [width]="112" [header]="'子コマ配置'"
              [binding]="'ChildKomaSettings'" [align]="'center'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <input type="checkbox" [checked]="cell.item.ChildKomaSettings == 1" id="ChildKomaSettings_{{cell.row.index}}"
                  (click)="eventChildKomaSettings_CHANGEHandler($event)" [tabindex]="-1" />
              </ng-template>
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <!-- 掲載順 1 のみ非表示、掲載順 2 以降は表示 -->
                <div *ngIf="cell.row.index > 0">
                  <input type="checkbox" [checked]="cell.item.ChildKomaSettings == 1" id="ChildKomaSettings_{{cell.row.index}}"
                  (click)="eventChildKomaSettings_CHANGEHandler($event)" [tabindex]="-1" />
                </div>
              </ng-template>
            </wj-flex-grid-column>
          </wj-flex-grid>
        
          <div class="layout_balance">
            <!-- 全行削除ボタン -->
            <button id="btn_Delete" class="btn-tartiary warning" (click)="eventRowDelete_CLICKHandler()" forcedEnabledMode="true"
              [tabindex]="0">全行削除</button>
              <!-- 行追加ボタン -->
            <button id="btn_Add" class="btn-secondary" (click)="eventRowAdd_CLICKHandler()" forcedEnabledMode="true"
            [tabindex]="0">行追加</button>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <!-- 設定ボタン -->
        <div class="footer-buttons">
          <button id="btn_Set" class="btn-primary" (click)="eventSetBtn_CLICKHandler()" forcedEnabledMode="true"
            [tabindex]="0">設定</button>
        </div>
        <!-- ×ボタン -->
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="eventClose_CLICKHandler()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>